import { useEffect, useState } from "react"
import { unstable_HistoryRouter, useNavigate, useParams } from "react-router-dom"
import { api } from "../../../env"
import LoadingButton from "../../../components/LoadingButton"
import ExpandingTextArea from "../../../components/ExpandingTextArea"

export default function TakeQuestionnaire() {

    const { id } = useParams()
    const navigate = useNavigate()
    const [enrollment, setEnrollment] = useState(undefined)
    const [question, setQuestion] = useState(undefined)

    useEffect(() => {
        if (id) api.get(`enrollments/${id}`)
            .then(res => {
                let {questionnaire, ...data} = res.data
                setEnrollment(data)
                setQuestion(getQuestion(questionnaire))
            })
            .catch(err => {})
    }, [id])

    const getQuestion = (questionnaire) => {
        const { totalQuestions, ...data} = questionnaire
        const { order, ...question } = data.currentQuestion
        return {
            ...question,
            last: order == totalQuestions,
            index: `${order}/${totalQuestions}`
        }
    }

    const handleQuestionChanged = (next) => {
        if (next) setQuestion(getQuestion(next))
        else navigate('../matching')
    }

    return(<div className="bg-target h-100 w-100" style={{marginTop: '-98px', height: 'calc(100% + 98px)'}}>
        <div className="showing standard-padding-sm columns flex center justify-end" style={{background: "rgb(var(--primary-dark))", color: "rgb(var(--on-primary-dark))"}}>
            <p className="section-title-s text-center lighter" style={{paddingTop: '88px'}}>Questionnaire for <span className="medium">{enrollment?.type}</span> at <span className="medium">{enrollment?.programName}</span></p>
        </div>
        {enrollment && question && <div className="standard-padding page-l-centered flex columns justify-center center">
            <Question enrollmentId={id} question={question} onQuestionChanged={handleQuestionChanged}/>
        </div>}
    </div>)
}

function Question({enrollmentId, question, onQuestionChanged}) {

    const [answer, setAnswer] = useState(undefined)
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        setAnswer(undefined)
        setLoading(false)
    }, [question])

    const handleAnswerChange = (val) => setAnswer(val)

    const handleSubmit = () => {
        setLoading(true)
        api.post(`enrollments/${enrollmentId}/submit-answer`, { answer })
            .then(res => onQuestionChanged(question.last ? null : res.data))
            .catch(_ => {})
    }

    return(<>
        <div className="flex center gap-xs v-spacer-xxs vi-spacer-xxl">
            <p className="card-label chip primary-dark-chip">{question.index}</p>
            <p className="section-title regular">{question.text}</p>
        </div>
        {["SingleAnswer", "MultiAnswer"].indexOf(question.answerType) != -1 && <CheckboxAnswers answers={question.answers} multiple={question.answerType == "MultiAnswer"} onChange={handleAnswerChange}/>}
        {["Text"].indexOf(question.answerType) != -1 && <TextAnswer onChange={handleAnswerChange}/>}
        <LoadingButton className={`solid-accent large vi-spacer-xl ${answer == undefined ? 'disabled' : ''}`} loading={loading} label={question.last ? 'Finish Questionnaire' : 'Next Question'} disabled={answer == undefined} onClick={handleSubmit}/> 
    </>)
}

function CheckboxAnswers({answers, multiple, onChange}) {

    const navigate = useNavigate()
    const [selected, setSelected] = useState([])
    useEffect(() => setSelected([]), [answers])

    useEffect(() => {
        if (selected.length == 0) onChange(undefined)
        else if (!multiple) onChange(selected[0] + 1)
        else onChange(selected.map(it => it + 1))
    }, [selected])

    const handleSelectionChanged = (idx) => {
        let index = selected.indexOf(idx)
        if (index == -1) {
            if (multiple) setSelected(it => [...it, idx])
            else setSelected([idx])
        }
        else setSelected(it => it.filter(i => i != it[index]))
    }

    const exploreTrack = (id) => navigate(`track/${id}`)

    return(<>
        <p className="card-label accent v-spacer-xxl">Select <span className="bold">{multiple ? 'multiple' : 'single'}</span> desired answer{multiple ? 's' : ''}</p>
        {answers.map((answer, idx) => <div className="flex gap-xs center v-spacer-xs" style={{width: "clamp(200px, 80%, 400px)"}}>
            <input type="checkbox" checked={selected.indexOf(idx) != -1} onClick={() => handleSelectionChanged(idx)} style={{width: '50px'}}/>
            <p className="card-body medium flex center gap-s">{answer?.text ? answer.text : answer} {answer?.value && <button className="elevated small" style={{whiteSpace: 'nowrap', flexShrink: 0}} onClick={() => exploreTrack(answer.value)}>Explore Track</button>}</p>
        </div>)}
    </>)
}

function TextAnswer({onChange}) {
    return(<div className="input-wrapper regular-border vi-spacer-xl" style={{height: 'unset', width: 'clamp(200px, 85%, 450px)'}}>
        <ExpandingTextArea placeholder={'Type out your answer...'} onChange={onChange}/>
    </div>)
}